import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { IUserSettings } from "../../services/user-settings-data/Models";
import UserSettingsDataService from "../../services/user-settings-data/UserSettingsDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";


type MutationContextType = {
    previous: IUserSettings | undefined;
};

export function useSaveUserSettings(params: BaseUseMutationParameters<void, IUserSettings>) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IUserSettings, MutationContextType>(
        (settings) => {
            return UserSettingsDataService.saveUserSettings(settings);
        },
        {
            onMutate: async (userSettings: IUserSettings) => {

                await queryClient.cancelQueries(keys.all);

                const previous = queryClient.getQueryData<IUserSettings>(
                    keys.settings()
                );



                queryClient.setQueryData<IUserSettings>(
                    keys.settings(),
                    (old?: IUserSettings) => {
                        //return old ?? userSettings;
                        return userSettings;
                    }
                );

                return {
                    previous
                };
            },
            onError: params.onError,
            onSuccess: params.onSuccess,
            onSettled: (_data, error, _userSettings, context) => {

                if (error && context?.previous) {
                    queryClient.setQueryData<IUserSettings>(
                        keys.settings(),
                        context?.previous
                    );
                }

                queryClient.invalidateQueries(keys.all);
            }
        }
    );
}
